// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"271":"css/caregiver","7981":"css/app.common","8252":"css/app","8502":"css/orientation-pdf"}[chunkId] + ".css";
};